import '../../../js/vendor/polyfills/polyfill-array-from.js';
import '../../../js/vendor/polyfills/polyfill-classlist.js';
import '../../../js/vendor/polyfills/polyfill-request-animation-frame.js';

import Component from '../../../js/core/component.js';
import Collapse from '../../../js/utilities/collapse/u-collapse.js';
import breakpoint from '../../../js/utilities/breakpoint/u-breakpoint.js';
import {detachWithPlaceholder, attachToPlaceholder} from '../../../js/utilities/detach-with-placeholder/u-detach-with-placeholder.js';

/**
 * Categories Class
 */
class Categories extends Component {

	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false,
			element: null,
			icons: false,
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		this.element = this.settings.element;
		this.appendToElement = document.querySelector('#' + this.element.getAttribute('data-place-after'));

		breakpoint('screen and (max-width: 767px)', {
			enter: () => {
				detachWithPlaceholder(this.element);
				this.appendToElement.after(this.element);
				this._initNarrow();
			},
			exit: () => {
				this._destroyNarrow();
				attachToPlaceholder(this.element);
			}
		});
	}

	_initNarrow () {
		this.collapsedElem = new Collapse({
			element: this.element,
			selectors: {
				header: '> .c-categories__title',
				content: '> .c-categories__content'
			},
			classNames: {
				collapsed: 'collapsed',
				button: 'c-categories__button'
			},
			icons: {
				collapsed: '/gui/images/icons/plus.svg',
				expanded: '/gui/images/icons/minus.svg'
			},
			prepareCssAnimation: true
		});
	}

	_destroyNarrow () {
		this.collapsedElem.destroy();
	}
}
document.addEventListener('newcontent', (e) => {
	e.target.querySelectorAll('.c-categories').forEach((categories) => {
		categories.categories = new Categories({
			element: categories
		});
	});
});

export default Categories;


// WEBPACK FOOTER //
// ./components/navigation/categories/c-categories.js